<template>
<div class="l_alert__invitation_success animation__background">
  <div class="l_alert__panel animation__popup">
    <div class="container">
      <p class="title">お友だち紹介スタンプを<br>{{this.point}}個GETしました。</p>
      <img class="l_img" :src="require('@/assets/img/register/invite-get-stamp-dialog-img@3x.png')" />
      <div class="description">
        <p>あなたが香の川製麺に来店して、 <br>来店スタンプをGETすると、<br>紹介してくれたお友だちにも<br>スタンプ{{this.inviterPoint}}個プレゼント♪</p>
      </div>
      <p class="description-info">※紹介リンク発行後から{{this.inviterExpireDays}}日以内の来店が対象です。</p>
      <div class="footer">
        <button @click="tapClose">閉じる</button>
      </div>
    </div>
  </div>
</div>
</template>

<script>
export default {
  name: 'AlertInvitationSuccess',
  props: {
    point: { type: String },
    inviterPoint: { type: String },
    inviterExpireDays: { type: String }
  },
  methods: {
    tapClose() {
      this.$emit('close')
    }
  }
}
</script>

<style scoped lang="scss">
.l_alert__invitation_success {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.8);
  display: flex;
  align-items: center;
  justify-content: center;
}

.l_alert__panel {
  width: 270px;
}

/* 背景表示のアニメーション */
.animation__background {
  animation: fadeIn 0.4s ease normal 0s none running;
}

/* popupアニメーション */
.animation__popup {
  animation: bounce 1s ease normal 0s none running;
}

@keyframes bounce {
  0%,
  100%,
  20%,
  50%,
  80% {
    transform: scale(1, 1);
  }
  40% {
    transform: scale(0.93, 0.93);
  }
  60% {
    transform: scale(0.98, 0.98);
  }
}

@keyframes fadeIn {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

.l_alert__invitation_success .container {
  display: flex;
  flex-direction: column;
  align-items: center;
  align-content: space-around;
  border: 1px solid #eeeeee;
  border-radius: 12px;
  background-color: #ffffff;
  padding: 20px 0 0 0;
}

.l_alert__invitation_success .container .title {
  font-family: 'HiraKakuPro-W6';
  font-size: 16px;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #000000;
  margin-bottom: 4px;
}

.l_img {
  width: 70%;
  overflow: hidden;
}
.freepass {
  height: 175px !important;
}

.c_img {
  max-width: 100%;
  vertical-align: bottom;
}

.l_alert__invitation_success .container .description {
  font-family: 'HiraKakuPro-W6';
  font-size: 13px;
  text-align: center;
  font-style: normal;
  font-weight: 600;
  font-stretch: normal;
  line-height: 1.54;
  letter-spacing: normal;
  color: #333333;
}

.l_alert__invitation_success .container .description-info {
  font-family: 'HiraKakuPro-W3';
  font-size: 10px;
  text-align: center;
  font-style: normal;
  font-weight: 300;
  font-stretch: normal;
  line-height: 1.54;
  color: #333333;
  padding-top: 2px;
}

.l_alert__invitation_success.container .description p:nth-child(1) {
  padding-top: 20px;
}

.l_alert__invitation_success .container .description .txt-highlight {
  color: #e03535;
}

.l_alert__invitation_success .container .footer {
  padding-top: 2px;
  width: 100%;
}

.l_alert__invitation_success .container .footer button {
  font-family: 'HiraKakuPro-W3';
  font-size: 13px;
  text-align: center;
  background-color: #ffffff;
  color: #602209;
  width: 100%;
  padding: 12px 0;
  outline: none;
  border-radius: 12px;
}

.l_alert__invitation_success .container .footer button:nth-child(1) {
  border: none;
  border-top: 1px solid #eeeeee;
}
</style>
